import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=923f2676&scoped=true&"
import script from "./useDetail.vue?vue&type=script&lang=js&"
export * from "./useDetail.vue?vue&type=script&lang=js&"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=923f2676&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f2676",
  null
  
)

export default component.exports